import { useCallback } from "react";
import useAjax from "@apis/useAjax";
import {
	GET_DEVICE_ORDER_MEMBER_API,
	GET_DEVICE_ORDER_API,
	POST_DEVICE_ORDERS_OVERVIEW_API,
	POST_DEVICE_ORDERS_EXPORT_OVERVIEW_API,
	POST_DEVICE_ORDERS_API,
	GET_DEVICE_ORDERS_EFFECTION_DEVICEORDERSID_API,
	GET_DEVICE_ORDERS_EFFECTION_OPTIONS_API,
	GET_DEVICE_ORDER_OPTIONS_API,
	POST_DEVICE_ORDERS_EFFECTION_DEVICEORDERSID_API,
	DELETE_DEVICE_ORDER_API,
	POST_DEVICE_ORDERS_RANGE_FEE_API,
	DELETE_DEVICE_ORDERS_EFFECTION_EFFECTID_API,
} from "@apis/apiPath";

const useDeviceOrderApi = () => {
	const Ajax = useAjax();

	// 申請下拉選單
	const getDeviceOrderApplyOptionsApi = useCallback(
		async () => {
			const resp = await Ajax.get(GET_DEVICE_ORDER_OPTIONS_API);
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	// 終止下拉選單
	const getDeviceOrderQuitOptionsApi = useCallback(
		async () => {
			const resp = await Ajax.get(GET_DEVICE_ORDERS_EFFECTION_OPTIONS_API);
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	// 智能系統訂閱單
	const getDeviceOrderDetailInfoApi = useCallback(
		async deviceOrderID => {
			const resp = await Ajax.get(GET_DEVICE_ORDER_API(deviceOrderID));
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	// 新增智能系統讀取會員資訊使用
	const getDeviceOrderMemberInfoApi = useCallback(
		async memberID => {
			const resp = await Ajax.get(GET_DEVICE_ORDER_MEMBER_API(memberID));
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	// 總覽資料
	const postDeviceOrderOrverviewApi = useCallback(
		async params => {
			const resp = await Ajax.post(POST_DEVICE_ORDERS_OVERVIEW_API, params);
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	// 智能系統總覽下載 Excel
	const postDeviceOrdersExportOverviewApi = useCallback(
		async params => {
			const resp = await Ajax.post(POST_DEVICE_ORDERS_EXPORT_OVERVIEW_API, params);
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	// 申請智能方案
	const postDeviceOrderApplyApi = useCallback(
		async params => {
			const resp = await Ajax.post(POST_DEVICE_ORDERS_API, params);
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	// 刪除申請智能方案(22天後不可刪除)
	const deleteDeviceOrderApplyApi = useCallback(
		async (params, deviceOrderID) => {
			const resp = await Ajax.delete(DELETE_DEVICE_ORDER_API(deviceOrderID), params);
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	// 刪除退訂變更單（取消退訂）
	const deleteDeviceOrderEffectionApi = useCallback(
		async (effectID, employeeID) => {
			const resp = await Ajax.delete(DELETE_DEVICE_ORDERS_EFFECTION_EFFECTID_API(effectID, employeeID));
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	// 退訂取得訂單資訊
	const getDeviceOrderQuitApi = useCallback(
		async id => {
			const resp = await Ajax.get(GET_DEVICE_ORDERS_EFFECTION_DEVICEORDERSID_API(id));
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	// 退訂單新增
	const postDeviceOrderQuitApi = useCallback(
		async (params, id) => {
			const resp = await Ajax.post(POST_DEVICE_ORDERS_EFFECTION_DEVICEORDERSID_API(id), params);
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	// 依智能行銷方案取得破月費、合約日期、開通設定費、首次扣款日
	const postDeviceOrderRangeFeeApi = useCallback(
		async params => {
			const resp = await Ajax.post(POST_DEVICE_ORDERS_RANGE_FEE_API, params);
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	return {
		getDeviceOrderQuitOptionsApi,
		getDeviceOrderDetailInfoApi,
		getDeviceOrderMemberInfoApi,
		postDeviceOrderOrverviewApi,
		postDeviceOrdersExportOverviewApi,
		postDeviceOrderApplyApi,
		getDeviceOrderQuitApi,
		getDeviceOrderApplyOptionsApi,
		postDeviceOrderQuitApi,
		deleteDeviceOrderApplyApi,
		postDeviceOrderRangeFeeApi,
		deleteDeviceOrderEffectionApi,
	};
};

export default useDeviceOrderApi;
